// extracted by mini-css-extract-plugin
module.exports = {"item":"Index_item__3wq-e","name":"Index_name__35y8B"};